// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__YRJUG","legacyBtn":"MutateMid_legacyBtn__D9_pg"};